




















































































































import { Component, Prop, Emit, Vue, Watch } from 'vue-property-decorator';
import DSelectbox from '@/components/DSelectbox/selectbox.vue';
import TreeDropDownBox from '@/components/TreeDropDownBox/tree-drop-down-box.vue';
import dicts_cache_service from '@/services/dicts_cache_service';
import BalanceService, { BalancePreset, groupingDataSource } from '@/services/balance-service';
import YearService from '@/services/years-service';
import {
  CutType,
  EcoFilialSelectionType,
  Period,
  YearType,
  SelectedGroupedObjects
} from '@/services/models-service';
import { DxCheckBox } from 'devextreme-vue/check-box';
import DxSelectBox from 'devextreme-vue/select-box';
import DxRadioGroup from 'devextreme-vue/radio-group';
import DxTagBox from 'devextreme-vue/tag-box';
import DButton from '@/components/DButton/button.vue';
import Nebalans from '@/components/HeaderSet/Nebalans.vue';
import _ from 'lodash';
import cutService from '@/services/cut-service';
import ShareService from '@/services/share-service';
import EcoObjectsService from "@/services/eco-objects-service";
import UserAccessService from '@/services/user_access_service';
import AuthService from '@/services/auth_service';
import PeriodTreeSelect from '@/components/PeriodTreeSelect/period-tree-select.vue';
import PeriodTreeSelectNew from '@/components/PeriodTreeSelect/PeriodTreeSelectNew.vue';
import {DxButton} from "devextreme-vue/ui/button";
import DPeriodTreeSelect from "@/components/PeriodTreeSelect/DPeriodTreeSelect.vue";
import GroupedObjectService from "@/services/grouped-object_service";

// Функция для группировки period_ds в дерево
function buildPeriodTree(period_ds: any[]) {
  const periodGroups = [
    {
      id: 'months',
      label: 'Месяцы',
      filter: (p: any) => [
        'january','february','march','april','may','june','july','august','september','october','november','december'
      ].includes(p.name)
    },
    {
      id: 'quarters',
      label: 'Кварталы',
      filter: (p: any) => p.display && /квартал/i.test(p.display)
    },
    {
      id: 'halfyears',
      label: 'Полугодия',
      filter: (p: any) => p.display && /полугодие/i.test(p.display)
    },
    {
      id: 'year',
      label: 'Год',
      filter: (p: any) => p.display && /^год$/i.test(p.display)
    },
    {
      id: 'growth',
      label: 'Нарастание',
      filter: (p: any) => p.display && /мес\./i.test(p.display) && /\(/.test(p.display)
    }
  ];
  return periodGroups.map(group => ({
    id: group.id,
    label: group.label,
    children: period_ds.filter(group.filter).map((p: any) => ({
      id: p.name,
      label: p.display
    }))
  })).filter(group => group.children.length > 0);
}


@Component({
  name: 'TransportHeaderSet',
  components: {
    DPeriodTreeSelect,
    DxButton,
    DSelectbox,
    DxSelectBox,
    DxCheckBox,
    TreeDropDownBox,
    DxRadioGroup,
    DxTagBox,
    DButton,
    Nebalans,
    PeriodTreeSelect,
    PeriodTreeSelectNew,
  }
})
export default class extends Vue {
  @Prop({default: false}) public disableSaveButton!: boolean;

  public service = BalanceService;
  public shareService = ShareService;
  public ecoService = EcoObjectsService;

  public fetchPreset = true; // Флаг ожидания загрузки пресета
  public show_pao_tplus = false;

  public preset = new BalancePreset();
  // Текущая основная срезка
  private currentCut: CutType | null = null;
  // источники данных для селектбоксов
  public year_ds = YearService.YearList;
  public period_ds = dicts_cache_service.periods_simple;
  public cut_ds: CutType[] = [];

  // доступность кнопки загрузить
  public availableLoad: boolean = true;
  public allowLoad:boolean = false;
  public periods: string[] = [];

  public permission_nodes: any[] = [];
  public disableSelector: boolean = false;

  private selectionData: EcoFilialSelectionType[] = [];
  public display_internal_revolutions: boolean = false;
  public show_deviation: boolean = false;
  public objectService = GroupedObjectService;
  public groupedObjects: SelectedGroupedObjects[] = [];
  public ignoreRootNodesList: string[] = ['months', 'quarters', 'halfyears', 'year_item', 'growth', 'wane'];

  onDisplayChange(e: any) {
    const newValue = e.value;
    this.display_internal_revolutions = newValue;
    this.$emit('displayInternalRevolutions', newValue);
  }

  onDeviationChange(e: any) {
    const newValue = e.value;
    this.show_deviation = newValue;
    this.$emit('showDeviation', newValue);
  }

  get relative_cut(): CutType[] {
    if (this.preset.id_year) {
      return this.cut_ds.filter((c) => c.id_year === this.preset.id_year && (c.visible_for === 'Видимый для администратора' || c.visible_for === 'Видимый для всех'));
    }
    return [];
  }

  get relative_compare_cut(): CutType[]  {
    // Версия справочника Доп срезки должна соответсвовать весии справочника основной
    if (this.preset.id_cut && this.currentCut) {
      return this.relative_cut.filter((c:CutType) => {
        return (c.id !== this.preset.id_cut) && (this.currentCut?.id_eco_version === c.id_eco_version)
      });
    }
    return [];
  }

  get availableNodes() {
    return this.selectionData.length > 0;
  }

  get buttonText(): string {
    return !this.allowLoad || !this.availableNodes || this.service.isBalanceLoading
      ? 'Обновить'
      : 'Загрузить';
  }

  async mounted() {
    this.fetchPreset = true;
    const today = new Date();
    this.service.loadFromCache();
    this.preset = _.cloneDeep(this.service.current);
    this.disableSelector = AuthService.isHeatNodeOperator();

    //если не задан год, по умолчанию задаем текущий
    if (!this.preset.id_year) {
      const current_year = Number(today.getFullYear());
      const default_year = this.year_ds.find(y => y.name === current_year);
      if (default_year) {
        this.preset.id_year = default_year.id;
      } else if (this.year_ds.length) {
        this.preset.id_year = this.year_ds[this.year_ds.length - 1].id
      }
    }

    // если не задан период, по умолчанию задаем текущий месяц
    if(!this.preset.period || this.preset.period.length < 1) {
      const current_mounth = today.toLocaleString("en-US", {month: 'long'},).toLowerCase();
      const default_period: Period = dicts_cache_service.periods.find((p: Period )=> p.name === current_mounth);
      this.periods = [ default_period.name || 'may' ];
      this.preset.period = this.periods;
    } else {
      this.periods = this.preset.period;
    }

    // Загрузить всевозможные срезки, зависящие от текущего года

    await this.getCutsYear();

    if (this.preset.id_cut) {
      this.currentCut = this.getCut(this.cut_ds) || null;
    } else {
      this.currentCut = null;
    }

    await this.updateFilialNodesTree();

    if(this.disableSelector) {
      // Показываем как выбранные филиалы и узлы, привязанные к текущему пользователю
      let user_nodes = AuthService.getHeatNodeId();
      // Оператор ТУ не может выбрать для всего ПАО "ТПлюс"
      this.preset.show_pao_tplus = false;
      this.preset.id_eco_heat_nodes = user_nodes;
      let filials_set = new Set<number>();
      for (const filial_uid in this.ecoService.filialNodesTree) {
        const filial_nodes = this.ecoService.filialNodesTree[filial_uid];
        for (const node_uid in filial_nodes) {
          const node = filial_nodes[node_uid];

          if (user_nodes.indexOf(node.id) !== -1) {
            filials_set = filials_set.add(node.filial_id)
          }
        }
      }
      this.preset.id_eco_filials = Array.from(filials_set)

    }

    let route = this.$route.name
    if(route) {
      this.permission_nodes = UserAccessService.checkReading(route);
    }

    this.createSelectionTreeStructure();
    await this.createGroupedObjectStructure();

    Vue.nextTick(() => {
      this.fetchPreset = false;
      this.seekPreset();
    });
  }

  async updateFilialNodesTree() {
    const year = this.getYear(this.year_ds) || null;
    const months = this.getMonthList();
    if (this.currentCut && year && months.length > 0) {
      await this.ecoService.update_filial_nodes_tree(this.currentCut.id_eco_version, year.name, months)
    }
  }

  getYear(year_ds: any[]) {
    return year_ds.find((y:YearType) => y.id === this.preset.id_year)
  }


  getCut(cut_ds: any[]) {
    return cut_ds.find((c:CutType) => c.id === this.preset.id_cut);
  }

  getMonthList() {
    const periodsList = this.periods.slice().filter(p => !this.ignoreRootNodesList.includes(p));
    let month_set: any[] = [];
    console.log(periodsList, '<periodsList>')
    console.log(this.period_ds)

    periodsList.forEach((period_name: string) => {
      const prd = this.period_ds.find((period: any) => {
        return period.name === period_name
      });

      if (prd) {
        const m = prd.months;
        month_set = prd.months.slice()
      }
    })
    console.log(month_set)

    return Array.from(new Set(month_set));
  }

  checkNodeAccess(nodeId: any) {
    return this.permission_nodes.includes(parseInt(nodeId))
  }

  // Формирование структуры для отображения дерева и установка выбранных значений согласно пресета
  private createSelectionTreeStructure() {

    let selectionData: EcoFilialSelectionType[] = [];

    for (const filial_uid in this.ecoService.filialNodesTree) {
      const filial_nodes = this.ecoService.filialNodesTree[filial_uid];

      let filialCheck = null;
      let filial_name = '';
      let filial_id = -1;
      let filial_date_from = '';
      let nodes: any[] = [];

      for (const node_uid in filial_nodes) {
        const node = filial_nodes[node_uid];
        if (_.isNil(filialCheck)) {
          filial_id = node.filial_id;
          filial_name = node.filial_name;
          filial_date_from = node.date_from;
          filialCheck = this.preset.id_eco_filials.includes(node.filial_id);
        }
        if (this.checkNodeAccess(node.id)) {
          const id = (node.id); // Идентификатор ТУ
          // Если филиал выбран, все узлы считать также выбранными, иначе проверять по данным пресета
          const check = filialCheck || this.preset.id_eco_heat_nodes.includes(node.id);
          nodes.push({id: node.id, name: node.name, check})
        }
      }

      // Не показывать филиалы, в которых нет доступных для текущего пользователя ТУ
      if (nodes.length) {
        selectionData.push({ id: filial_id, name: filial_name, nodes, date_from: filial_date_from, check: !!filialCheck });
      }
    }

    this.selectionData = selectionData;

    this.checkAvalible();
  }

  private async createGroupedObjectStructure() {
    if (this.preset.id_cut) {
      let groupedObjects = await this.objectService.getObjectsByCut(this.preset.id_cut ?? '');
      this.groupedObjects = groupedObjects.map(el => ({
        id: el.id,
        title: el.title,
        check: this.groupedObjects.find(existing => existing.id === el.id)?.check || false, // Сохраняем состояние check
      }));
    } else {
      this.groupedObjects = []; // очищаем если нет срезки
    }
  }

  confirmSave() {
    const id_eco_filials: number[] = [];
    this.selectionData.forEach(fililalSelection => {
      // Обновляем только список филиалов, узлы записываются в id_eco_heat_nodes в онлайн режиме
      // (см. метод nodeSelectionChanged )
      if (fililalSelection.check && fililalSelection.id) {
        id_eco_filials.push(fililalSelection.id);
      }
    });
    // Список филиалов передаётся отдельно как параметр, чтобы не сработал вотчер на SeekPreset
    this.service.setCurrent({ ...this.preset, id_eco_filials });
  }

  onGroupedObjectChanged(items: string[]) {
    this.$emit('selectedGroupedObjectChanged', items);
  }

  // Обновление списка выбранных ТУ в онлайн режиме
  onHierarchyChanged({ filials, nodes, facilities }: {
    filials: number[];
    nodes: number[];
    facilities: number[];
  }) {
    if (this.fetchPreset) {
      return;
    }

    this.preset.id_eco_heat_nodes = nodes;

    // Собираем имена выбранных объектов (тепловых узлов)
    const selectedNames: string[] = [];
    for (const filial of this.selectionData) {
      for (const node of filial.nodes) {
        if (nodes.includes(node.id)) {
          selectedNames.push(node.name);
        }
      }
    }
    this.$emit('selectedObjectsChanged', selectedNames);
  }

  @Emit('onLoad')
  onLoad() {
    this.allowLoad = false;
    this.confirmSave();
    this.seekCutName();
  }

  @Emit('onSave')
  onSave() {

  }

  @Emit('onExport')
  onExport() {
  }

  @Emit('checkAvalible')
  checkAvalible() {
    return this.selectionData.length > 0;
  }

  @Emit('checkAllFilters')
  checkAllFilters() {
    return this.preset.id_year && this.preset.period?.length && this.preset.id_cut;
  }

  @Watch('preset.id_cut')
  async changeCutId() {
    if (this.fetchPreset) {
      return;
    }
    if (!this.preset.id_cut) {
      this.currentCut = null;
    } else {
      this.currentCut = this.cut_ds.find(cut => this.preset.id_cut === cut.id) || null;
    }

    this.preset.id_eco_heat_nodes = [];
    this.preset.id_eco_filials = [];

    await this.updateFilialNodesTree();
    this.createSelectionTreeStructure();;
    await await this.createGroupedObjectStructure();
  }

  @Watch('preset.id_year')
  changeYear() {
    if (this.fetchPreset) {
      return;
    }
    this.shareService.share_year_id = this.preset.id_year;
    this.preset.id_cut = null;
    this.getCutsYear();
  }

  @Watch('preset.show_cut')
  resetCut() {
    if (this.fetchPreset) {
      return;
    }
    //если переключить check-box значение обнуляется
    this.preset.id_cut = null;
  }

  @Watch('preset.show_compare_cut')
  resetSecondaryCut() {
    if (this.fetchPreset) {
      return;
    }
    //если переключить check-box значение обнуляется
    this.preset.id_compare_cut = null;
  }

  @Emit('cutName')
  seekCutName() {
    const result = {name: '', secondary: ''}
    result.name = this.currentCut?.name || "";
    if (this.preset.show_compare_cut && this.preset.id_compare_cut) {
      const compare_cut = this.relative_cut.find(c => c.id === this.preset.id_compare_cut);
      result.secondary = compare_cut ? compare_cut.name : "";
    }
    return result;
  }

  @Watch('preset', { deep: true })
  seekPreset() {
    if (this.fetchPreset) {
      return;
    }

    this.availableLoad = true;
    // Кнопка загрузки доступна, если выбраны основная срезка, период и год, а также хотя бы один объект (ПАО или ТУ)
    if(
      this.preset.id_cut &&
      this.preset.period?.length > 0 &&
      (this.preset.show_pao_tplus || (this.preset.id_eco_heat_nodes.length))
    ) {
      this.allowLoad = true;
    } else {
      this.allowLoad = false;
    }
    this.service.allowExcelExport = false;

    this.shareService.share_year_id = this.preset.id_year;
    this.shareService.share_cut_id = this.preset.id_cut;
  }

  @Watch('periods')
  async changePeriods(newValue:any, oldValue:any) {


    if (this.fetchPreset) {
      return;
    }
    const periodsList = this.periods.slice().filter(p => !this.ignoreRootNodesList.includes(p));

    this.preset.period = periodsList;
    // this.preset.id_eco_heat_nodes = [];
    // this.preset.id_eco_filials = [];

    // await this.updateFilialNodesTree();
    // this.createSelectionTreeStructure();
    await this.createGroupedObjectStructure();
  }


  async getCutsYear() {
    if (this.preset.id_year) {
      const response = await cutService.getWithFilter(this.preset.id_year);
      if (response.data) {
        const sorted = _.sortBy(response.data, [(o) => o.number]);
        this.cut_ds = sorted;
      }
    }
  }
  // endregion запросы для наполения источников данных селектбоксов

  get periodTreeData() {
    return buildPeriodTree(this.period_ds);
  }
}
